module.exports = __webpack_public_path__ + "fonts/Inter-900-greek81.4a4b49c.woff2";